__turbopack_context__.v({
  "badge": "PillCard-module__q-CTvW__badge",
  "pill": "PillCard-module__q-CTvW__pill",
  "row": "PillCard-module__q-CTvW__row",
});
